export default "__VITE_ASSET__BwntmSm6__";